<ul class="mx-4" *ngIf="taggedPuffs$ | async as taggedPuffs">
  <li
    py-megamenu-list-item
    aria-controls="collapse-navigation-services"
    (click)="collapse.toggle()"
    [attr.aria-expanded]="!isCollapsed"
    [ngClass]="{ active: !isCollapsed }"
  >
    <a>
      <i *ngIf="labelAntIcon" nz-icon [nzType]="labelAntIcon" nzTheme="outline" class="pr-2"></i>
      {{ label }}
    </a>
  </li>
  <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
    <ul py-menu-services-items [uids]="taggedPuffs">
      <li py-megamenu-list-item [isDirectLink]="true">
        <cx-generic-link [url]="'/' + filterTag">
          {{ 'navigation.viewAllFilterTags' | cxTranslate : { context: filterTag + '_action_mobile' } }}
        </cx-generic-link>
      </li>
    </ul>
  </div>
</ul>
